export default {
  name: 'TopNav',

  data() {
    return {
      isPopups: false
    };
  }

};